<template>
    <button
        v-if="!href"
        :type="type"
        class="def-button-primary btn btn-std"
    >
        <slot />
    </button>
    <a v-else :href="href" class="def-button-primary btn btn-std">
        <slot />
    </a>
</template>

<script>
export default {
    name: 'DefButtonPrimary',
    props: ['href', 'type'],
}
</script>

<style lang="scss" scoped>
.def-button-primary{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    @include point-md{
        height: 50px;
    }
}
</style>